import {useObjectConfig} from './useConfig'
import { useParseDate } from '@octavius-rocks/ui'
import {DEFAULT_DASHBOARD_QUERY_ARGS} from "../data/defaults";

export const useDashboardQueryArgs = (defaultArgs = {})=>{
    const parseDate = useParseDate()
    const [args, set] = useObjectConfig(defaultArgs, "queryArgs_Dashboard")

	const from = (typeof args.from === typeof "") ? parseDate(args.from): args.from;
    const to = (typeof args.to === typeof "") ? parseDate(args.to): args.to;

    // migrate to new condition filter ui
    let conditions = args.conditions;
    if(Array.isArray(conditions) && typeof conditions["relation"] !== "string"){
        conditions = DEFAULT_DASHBOARD_QUERY_ARGS.conditions;
    }

    return [{
        ...args,
        conditions,
        from,
        to
    },set]
}